function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionNormalIdle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.03763 0.538462C3.46535 -0.179487 4.53465 -0.179488 4.96237 0.538461L7.84946 5.38462C8.27718 6.10257 7.74254 7 6.8871 7H1.1129C0.257467 7 -0.277182 6.10257 0.150536 5.38462L3.03763 0.538462Z",
    fill: "#F79009",
    style: {
      fill: "#F79009",
      fill: "color(display-p3 0.9686 0.5647 0.0353)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionNormalIdle);
export default __webpack_public_path__ + "static/media/direction-normal-idle.e0faf3742d04788ad049020bdc1e8974.svg";
export { ForwardRef as ReactComponent };